export const LOCAL_AUTH_BYPASS_ROLES = [
  'SYSTEM_ADMIN',
  'ADMIN',
  'AGENCY_OWNER',
  'AGENCY_MANAGER',
  'MANAGER',
  'ADVISOR',
] as const;

export type LocalAuthBypassRole =
  (typeof LOCAL_AUTH_BYPASS_ROLES)[number];

export const DEFAULT_LOCAL_AUTH_BYPASS_ROLE: LocalAuthBypassRole = 'ADVISOR';
